import { Injectable } from '@angular/core';
import { DatabaseService } from './database.service';
import { BehaviorSubject } from 'rxjs';
import { DateTimeService } from './date-time.service';
import { GisService } from './gis.service';
import { CampaignLoyaltyProgramme, IndefiniteLoyaltyProgramme, Outlet, OutletWithDealz, Puck } from '../models/interfaces';
import { supportedProductTypes } from '../models/enums';
import { PreferencesService } from './preferences.service';
import { ListsService } from './lists.service';

@Injectable({
  providedIn: 'root'
})
export class OutletDealzService {
  private _browsingOutletsWithDealz:OutletWithDealz[]=[]
  browsingOutlets$: BehaviorSubject<Outlet[]> = new BehaviorSubject<Outlet[]>([]);
  private inMemoryOutlets:Outlet[] = []
  constructor(
    private dateTimeService:DateTimeService,
    private database:DatabaseService,
    private gisService:GisService,
    private preferencesService:PreferencesService,
    private listsService:ListsService
  ) { 

  }

  async fetchaSpecial(userUid:string,shopId:string,specialId:string){
    const specialInMemory = this.returnSpecialFromBrowsingSpecialsIfThere(specialId)
    if(specialInMemory){
      return specialInMemory
    }else{
      return this.database.fetchaSpecial(userUid,shopId,specialId);
    }
  }

  async fetchaCouponListing(userUid:string,shopId:string,couponListingId:string){
    return this.database.fetchaCouponListing(userUid,shopId,couponListingId);
  }

  async fetchOutlet(userId:string,shopId:string,outletId:string){
    return this.database.getOutletWithId(userId,shopId,outletId);
  }

  fetchOutletFromOutletGroup(outletId:string){
    return this.database.getOutletFromCollectionGroup(outletId);
  }

  fetchOutletShop(outlet:Outlet){
    return this.database.getShopWithOutlet(outlet);
  }

  fetchPuckShop(puck:Puck){
    return this.database.getShopWithPuck(puck);
  }

  fetchPuckOutlet(puck:Puck){
    return this.database.getOutletWithPuck(puck);
  }

  returnSpecialFromBrowsingSpecialsIfThere(specialUid:string){
    for (let index = 0; index < this._browsingOutletsWithDealz.length; index++) {
      const outlet = this._browsingOutletsWithDealz[index]
      const foundDeal = outlet.dealz.find(deal=>{
        return deal.id == specialUid
      })
      if(foundDeal){
        return foundDeal  
      }
    }
  }
  
  async fetchOutletsInArea(center:[number,number],radiusInM:number){
   let outlets = await this.database.fetchAllVerifiedOutletsAtLocation(center,radiusInM,supportedProductTypes.LOYALTY_PROGRAMMES);
    this.gisService.sortTheseObjectsByDistanceFrom(
      outlets,
      center[0],
      center[1]
    )
    const browsingOutletsWithDealz = await this.getActiveDealzOfTheseOutlets(outlets)
    this.browsingOutlets$.next(browsingOutletsWithDealz);
  }  

  async fetchAllOutlets(options?:{
    center?:[number,number],
    notify:boolean,
  }){

    // if(!this.listsService.outletsDoc){
    //   console.log('no outletsDoc');
    //   throw new Error("no outletsDoc");
    // }
    
    //const outlets:Outlet[] = []
    // first check if there are stored outlets that need updating
    //const storedOutlets = []//await this.preferencesService.retrieveOutlets();
    
    // if there is nothing stored fetch and store and return
    if(!this.inMemoryOutlets || this.inMemoryOutlets.length == 0){
      this.inMemoryOutlets = await this.database.fetchAllOutlets();
      //await this.preferencesService.saveOutlets(outlets);
    }
    
    // if there are stored outlets compare it with the latest outlet listing doc
    // for (let index = 0; index < this.inMemoryOutlets.length; index++) {
    //   const storedOutlet = this.inMemoryOutlets[index];
     
    //  // const outletListingInfo = this.listsService.outletsDoc[storedOutlet.id] as { revision: number; subscribed: boolean; verified: boolean }
    //   // if it is not in the listing doc it has been deleted.
    //   // remove it from stored list
    //   if(!outletListingInfo){
    //     await this.preferencesService.deleteOutlet(storedOutlet);
    //   } else {
    //     // if the revision number is the same it means it has not updated.
    //     // push it to the return list
    //     if(outletListingInfo.revision == storedOutlet.revision){
    //       outlets.push(storedOutlet);
    //       // fetch the latest outlet if revision number is different.
    //       // and store it
    //     } else {
    //       const freshOutlet = await this.fetchOutlet(storedOutlet.user_uid,storedOutlet.shop_id,storedOutlet.id);
    //       await this.preferencesService.replaceOutlet(freshOutlet)
    //       outlets.push(freshOutlet)
    //     }
    //   } 
      
    // }

    //fetch any outlets that are new in the listingDoc
    //const listOfOutletIds = Object.keys(this.listsService.outletsDoc)
    // for (let index = 0; index < listOfOutletIds.length; index++) {
    //   const id = listOfOutletIds[index];
    //   const storedOl = storedOutlets.find(ol=>{
    //     return ol.id = id
    //   })
    //   if(!storedOl){
    //     const freshOutlet = await this.fetchOutletFromOutletGroup(id);
    //     await this.preferencesService.replaceOutlet(freshOutlet);
    //     outlets.push(freshOutlet);
    //   }
    // }

  
  
    const subscribedOutlets = this.inMemoryOutlets.filter((outlet)=>{
      return outlet.verified && outlet.loyalty_programmes
    })

    if(options && options.center && options.center[0] && options.center[1]){
      this.gisService.sortTheseObjectsByDistanceFrom(
        subscribedOutlets,
        options.center[0],
        options.center[1]
      )
    }else{
      subscribedOutlets.sort((a,b)=>{
        if (a.name && b.name) {
          return a.name.localeCompare(b.name);
        } else {
          return 0;
        }
      })
    }

 
    if(options.notify){
      this.browsingOutlets$.next(subscribedOutlets);
      return subscribedOutlets
    }else{
      return subscribedOutlets
    }
   }  

  async fetchDealzOfThisOutlet(outlet:Outlet){
    if(!outlet.loyalty_programmes){
      return []
    }
      return this.database.getShopActiveDealz(outlet.shop_id)
   }   

  giveOutletDayFromTradingHours(outlet:Outlet,day:'Monday'|'Tuesday'|'Wednesday'|'Thursday'|'Friday'|'Saturday'|'Sunday'){
    if(!day||!outlet){
      throw new Error("outlet or day is nullish"); 
    }
    switch (day) {
      case 'Monday':
      case 'Tuesday':
      case 'Wednesday':
      case 'Thursday':
      case 'Friday':
        return outlet.trading_from
      case 'Saturday':
        return outlet.saturday_trading_from
      case 'Sunday':
        return outlet.sunday_trading_from
      default:
        return outlet.holiday_trading_from
    }
  }
  
  giveOutletDayToTradingHours(outlet:Outlet,day:'Monday'|'Tuesday'|'Wednesday'|'Thursday'|'Friday'|'Saturday'|'Sunday'){
    if(!day||!outlet){
      throw new Error("outlet or day is nullish"); 
    }
    switch (day) {
      case 'Monday':
      case 'Tuesday':
      case 'Wednesday':
      case 'Thursday':
      case 'Friday':
        return outlet.trading_to
      case 'Saturday':
        return outlet.saturday_trading_to
      case 'Sunday':
        return outlet.sunday_trading_to
      default:
        return outlet.holiday_trading_to
    }
  }

  isOutletAvailableNowOrLaterOrMissed(outlet:Outlet,day:'Monday'|'Tuesday'|'Wednesday'|'Thursday'|'Friday'|'Saturday'|'Sunday'){
    const from = this.giveOutletDayFromTradingHours(outlet,day)
    const to = this.giveOutletDayToTradingHours(outlet,day)
    
    if(this.dateTimeService.isCurrentTimeBetween(from,to)){
      return 'now'
    }
    if(this.dateTimeService.isCurrentTimeBefore(from)){
      return 'later'
    }
    if(this.dateTimeService.isCurrentTimeAfter(to)){
      return 'missed'
    }
  }

  private async getActiveDealzOfTheseOutlets(outlets:Outlet[]) {
    let promises:Promise<(CampaignLoyaltyProgramme | IndefiniteLoyaltyProgramme)[]>[]= [];
    outlets.forEach(outlet => {
      promises.push(this.fetchDealzOfThisOutlet(outlet))
    });
    let dealzPerOutlet = await Promise.all(promises);
    return this.constructBrowsingOutletsWithDealzFromArrayOfOutlets(outlets,dealzPerOutlet);
  }

  private constructBrowsingOutletsWithDealzFromArrayOfOutlets(outlets:Outlet[],dealzPerOutlet:(CampaignLoyaltyProgramme | IndefiniteLoyaltyProgramme)[][]){
    this._browsingOutletsWithDealz.splice(0,this._browsingOutletsWithDealz.length)
    outlets.forEach((outlet)=>{
      let outletDealzArray = dealzPerOutlet.find((dealz)=>{
        if(dealz.length > 0){
          return dealz[0].restaurant_id == outlet.shop_id
        }
        return false
      })
      this._browsingOutletsWithDealz.push({...outlet,dealz:outletDealzArray?outletDealzArray:[]})
    })
    return this._browsingOutletsWithDealz
  }
}

